import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '../../../store/auth.store';
import { ERoutes } from '../../enums';
import { ToasterService } from '../../../services/toaster/toaster.service';

export const subscripedGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const toaster = inject(ToasterService);
  if (authStore.hasTravelerAccess()) return true
  toaster.addWarning('Sorry, In order to be traveler you have to subscribe in one of our plans')
  return router.createUrlTree([`/${ERoutes.subscription}`])
};
